/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { Column, ColumnsInterface } from '@irian-ro/util-table';
import { FilterMatchMode } from 'primeng/api';

export class DriverTimesheetViewModel extends JSONable {
  expenseYear: string = new Date().getFullYear().toString();
  expenseMonth: string = (new Date().getMonth() + 1).toString();

  @Column({
    header: 'timesheet.date',
    filterType: 'date-range',
    filterMatchMode: FilterMatchMode.BETWEEN,
  })
  logDate: string | undefined;

  @Column({
    header: 'timesheet.dayOfTheWeek',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  dayOfTheWeek: string | undefined;

  @Column({
    header: 'timesheet.driver',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  driverName: string | undefined;

  @Column({
    header: 'timesheet.type',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  driverTimesheetTypeLabel: string | undefined;

  @Column({
    header: 'timesheet.dailyAllownace',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.EQUALS,
  })
  dailyAllowance: number | undefined;

  @Column({
    header: 'timesheet.weekendSupplement',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.EQUALS,
  })
  weekendSupplement: number | undefined;

  @Column({
    header: 'timesheet.country',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  country: string | undefined;

  static _columns: ColumnsInterface[] | undefined = undefined;
}
